import { useEffect, useState } from 'react'
import Scene from '../components/game/Game';
import Sidebar from '../components/Sidebar';
import useEvent from '../hooks/useEvent';

function Landing() {
    const [isMobile, setIsMobile] = useState(true);
    const [fact, setFact] = useState(0.75);

    const checkMobileRes = (width: number) => {
        //64em
        var computedStyle = window.getComputedStyle(document.documentElement);
        var remWidth = width / parseInt(computedStyle.fontSize);

        if (remWidth < 64) {
            if (!isMobile) {
                setIsMobile(true)
            }

            document.querySelector('body')!.classList.remove('no-scroll');
        } else {
            if (isMobile) {
                setIsMobile(false)
            }


            if (!document.querySelector('body')!.classList.contains('no-scroll')) {
                document.querySelector('body')!.classList.add('no-scroll');
            }
        }

        var gameWidth = 0.75 * width;
        var aspectRatio = gameWidth / window.innerHeight;

        if (aspectRatio > 1.77){
            var desiredWidth = 1.77 * window.innerHeight;
            if ((desiredWidth / width) !== fact){
                setFact(desiredWidth / width);
            }
        } else {
            if (0.75 !== fact){
                setFact(0.75);
            }
        }
    }

    const handleResize = () => {
        window.scrollTo(0, 0);
        checkMobileRes(window.innerWidth);
    }

    let el;

    if (isMobile) {
        el = <>
            <Sidebar hasSettings={false}>
                <div className="sidebar__header">Hi!</div>
                <div className="sidebar__content">
                    <span id='im'>I'm John.</span>
                    <span id='gettoknow'>Get to know me by making your way to the glowing orbs</span>
                    <span id='note'>On a bit of a time crunch?</span>
                    <span id='noteSec'>Not a problem :)) Use the hamburger menu in the top right!</span>
                </div>
            </Sidebar>
        </>
    } else {
        el = <>
            <Scene fact={fact}/>
        </>
    }

    checkMobileRes(window.innerWidth);

    useEvent('resize', handleResize);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'John Chen | Game';
    }, [])

    return (
        <div style={{ display: "flex" }}>
            {el}
        </div>
    )
}

export default Landing
